<template>
  <v-row no-gutters>
    <v-col cols="12">
      <UploadImages ref="uploadImages" />
    </v-col>
    <v-col cols="12" md="12"
      ><AddEditHostDetails
        ref="addEditHostDetails"
        :isEditMode="isEditMode"
        :isSuperUserDashboard="isSuperUserDashboard"
    /></v-col>
    <v-col cols="12">
      <AddEditEventDetails ref="addEditEventDetails" :isEditMode="isEditMode" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import AddEditHostDetails from "./AddEditHostDetails";
import UploadImages from "./UploadImages";
import AddEditEventDetails from "./AddEditEventDetails";

export default {
  props: {
    isEditMode: { type: Boolean, default: false },
    isSuperUserDashboard: { type: Boolean, default: false },
    displayImageURLError: { type: Boolean, default: false },
  },
  components: {
    AddEditHostDetails,
    UploadImages,
    AddEditEventDetails,
  },
  computed: {
    ...mapGetters(["currentEvent"]),
  },
  methods: {
    validate() {
      return (
        this.$refs.uploadImages.validatePage() &&
        this.$refs.addEditHostDetails.validatePage() &&
        this.$refs.addEditEventDetails.validatePage()
      );
    },
  },
};
</script>

<style scoped>
.v-picker__title {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}

.v-slide-group__content.v-tabs-bar__content {
  background-color: #002434;
}

::v-deep .mc-checkbox .v-label {
  font-size: 14px;
}

.cursor-disabled {
  cursor: not-allowed !important;
  pointer-events: none;
}
</style>